import endpoints, { axios } from "../config/api";

function getUserNotifications(page: number) {
  return axios.get(endpoints.account.notifications(page));
}

export default getUserNotifications;
